<app-form-base *ngIf="companyForm" [formGroup]="companyForm">
  <ng-container content>
    <div class="billingForm__content-row">
      <div class="billingForm__content-row__inputs" #legalName>
        <app-form-text-input
          #legalName
          [ngStyle]="{ 'width': '100%' }"
          [form]="companyForm"
          [formControlSelector]="companyName"
          [id]="companyName"
          [maxLength]="50"
          [isSubmitted]="isSubmitted"
          [placeholder]="'BOOKING_MODULE.BILLING.COMPANY_NAME' | transloco"
          (keyUp)="changeUpperCaseName($event, companyName, companyForm)"
          (click)="scroll(legalNameRef)">
        </app-form-text-input>
      </div>
    </div>
    <div class="billingForm__content-row" #documentNumber>
      <div class="billingForm__content-row__inputs">
        <app-form-document-input
          #documentSelectorRef
          [form]="companyForm"
          [documents]="documents$ | async"
          [isSubmitted]="isSubmitted"
          [travelerBookingProvider]="bookingType"
          [documentNumberSelector]="documentNumberSelector"
          [configurationDocumentId]="configurationDocumentId"
          [type]="type"
          [defaultDocument]="defaultDocument$ | async"
          [validators]="formDocumentValidations$ | async"
          [documentType]="documentType$ | async"
          [isMobile]="isMobile"
          (documentSelected)="onDocumentTypeSelected($event)">
        </app-form-document-input>
      </div>
    </div>
    <app-address-form #addressFormRef
      [form]="companyForm"
      [countries]="countries"
      [cities]="cities"
      [isActiveForm]="true"
      [isSubmitted]="isSubmitted"
      [disabledCountryOptions]="disabledCountryOptions"
      [userAddresses]="userAddresses"
      [defaultBilling]="defaultBilling"
      [selectedCityCode]="selectedCityCode"
      [isMobile]="isMobile"
      (selectedCountry)="selectedCountry($event)"
      (selectedCity)="selectedCity($event)">
    </app-address-form>
    <div class="billingForm__content-row contact" #email>
      <app-form-text-input
        [form]="companyForm"
        [formControlSelector]="emailSelector"
        [id]="emailSelector"
        [maxLength]="50"
        [formInputType]="emailInputType"
        [isSubmitted]="isSubmitted"
        [placeholder]="'BOOKING_MODULE.CONTACT_INFO.EMAIL' | transloco"
        (click)="scroll(emailRef)">
      </app-form-text-input>
    </div>
    <div class="billingForm__content-row input-checkbox" *ngIf="!hasDefaultBillingInfo">
      <div class="billingForm__content-row__inputs">
        <fieldset class="input">
          <div class="checkbox">
            <input id="add-company-list" [checked]="saveFormData" autocomplete="off" maxlength="50" type="checkbox" (click)="setSaveFormData()">
            <label for="add-company-list" class="last-name">{{'BOOKING_MODULE.BILLING.SAVE_IN_THE_LIST' | transloco}}</label>
          </div>
        </fieldset>
      </div>
    </div>
  </ng-container>

  <ng-container button>
    <ng-container *ngIf="isMobile; else desktopCompanyBtn">
      <app-fixed-surface>
        <ng-container *ngTemplateOutlet="buttonCompBilling"></ng-container>
      </app-fixed-surface>
    </ng-container>
  
    <ng-template #desktopCompanyBtn>
      <div class="billingForm__button__desktop">
        <ng-container *ngTemplateOutlet="buttonCompBilling"></ng-container>
      </div>
    </ng-template>

    <ng-template #buttonCompBilling>
      <app-ds-button
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.BILLING.SAVE' | transloco }"
        (clickEvent)="save()">
      </app-ds-button>
    </ng-template>
  </ng-container>

</app-form-base>

